import { createContext, useContext } from "react";
import type { CareerServicesDashboardSection } from "../queries";

export type CareerServicesDashboardSectionSelection = {
  sections: CareerServicesDashboardSection[];
  sectionId: string | null;
  setSectionId: (sectionId: string | null) => void;
  requiresSectionSelection: boolean;
  loaded: boolean;
  canView: boolean;
  loading: boolean;
  error: Error | undefined;
  retry: () => void;
  ready: boolean;
};

const DEFAULT_SECTION_SELECTION: CareerServicesDashboardSectionSelection = {
  sections: [],
  sectionId: null,
  setSectionId: () => {},
  requiresSectionSelection: false,
  loaded: false,
  canView: false,
  loading: false,
  error: undefined,
  retry: () => {},
  ready: false
};

export const CareerServicesDashboardSectionSelectionContext =
  createContext<CareerServicesDashboardSectionSelection>(DEFAULT_SECTION_SELECTION);

export function useCareerServicesDashboardSectionSelection() {
  return useContext(CareerServicesDashboardSectionSelectionContext);
}
